import { render, staticRenderFns } from "./CallSound.vue?vue&type=template&id=5d2b62eb&"
import script from "./CallSound.vue?vue&type=script&lang=ts&"
export * from "./CallSound.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports